export default "<app-settings-tab-group></app-settings-tab-group>\r\n";